import { Injectable } from '@angular/core';
import { Observable, Subject } from "rxjs";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { fuseConfig } from '../../../fuse-config';
@Injectable({
    providedIn: 'root'
})
export class ProfileService {
    private subject;
    private residentChange;
    public building: any = {};
    public languages: any = [];
    public language: any = "en";
    constructor(private http: HttpClient) {
      this.subject = new Subject();
      this.residentChange = new Subject();
    }

    setLanguage(language): void {
        this.language = language;
        this.subject.next(language);
    }

    subscribe(next, error?, complete?): any {
        return this.subject.subscribe(next, error, complete);
    }

    residentChanged(resident): any {
        this.residentChange.next(resident);
    }

    subscribeResident(next, error?, complete?): any {
        return this.residentChange.subscribe(next, error, complete);
    }

    getOwnerHouses(): Observable<any> {
        const headers = new HttpHeaders().set('Login-Origin', 'web');
        return this.http.get( fuseConfig.url + '/owner/unitHouses', {headers: headers});
    }

    getRelatives(): Observable<any> {
        const headers = new HttpHeaders().set('Login-Origin', 'web');
        return this.http.get( fuseConfig.url + '/owner/relatives?invited=true&registered=true', {headers: headers});
    }

    getProfile(): Observable<any> {
        return this.http.get(fuseConfig.url + '/profile/getProfile');
    }

    changePassword(model): Observable<any> {
        return this.http.put(fuseConfig.url + '/profile/changePassword', model);
    }

    changeName(model): Observable<any> {
        return this.http.put(fuseConfig.url + '/profile/changeName', model);
    }

    changePhone(model): Observable<any> {
        return this.http.put(fuseConfig.url + '/profile/changePhone', model);
    }

    createUserUnit(building, body): Observable<any> {
        return this.http.post(fuseConfig.url + '/buildingAdmin/BuildingUserUnit/' + building, body);
    }

    getResidents(unit): Observable<any> {
        const headers = new HttpHeaders().set('Login-Origin', 'web');
        return this.http.get( fuseConfig.url + '/owner/getUnitResidents/' + unit, {headers: headers});
    }

    createResidentUser(body): Observable<any> {
        const data = {...body};
        data.img = data.img != null ? data.img.includes('data:image/png;base64') ? data.img.replace('data:image/png;base64,', '') : data.img.includes('data:image/jpeg;base64') ? data.img.replace('data:image/jpeg;base64,', '') : null : null;
        return this.http.post( fuseConfig.url + '/owner/createResidentUser', data);
    }

    changePhoto(body): Observable<any> {
        const data = {...body};
        data.img = data.img != null ? data.img.includes('data:image/png;base64') ? data.img.replace('data:image/png;base64,', '') : data.img.includes('data:image/jpeg;base64') ? data.img.replace('data:image/jpeg;base64,', '') : null : null;
        return this.http.put( fuseConfig.url + '/profile/changePhoto', data);
    }

    changeLanguage(body): Observable<any> {
        return this.http.put( fuseConfig.url + '/profile/changeLanguage', body);
    }

    getResidentRelations(): Observable<any> {
        return this.http.get( fuseConfig.url + '/owner/residentRelation');
    }

    getPhoneCarrier(): Observable<any> {
        return this.http.get(fuseConfig.url + '/shared/phone_carrier');
    }

    updateResident(body): Observable<any> {
        return this.http.put( fuseConfig.url + '/owner/resident', body);
    }

    updateUnitPin(body): Observable<any> {
        return this.http.put( fuseConfig.url + '/owner/unitPin', body);
    }

    getDealer(): Observable<any> {
        return this.http.get(fuseConfig.url + '/buildingCreator/dealer/user');
    }

    getDealerUsers(): Observable<any> {
        return this.http.get(fuseConfig.url + '/buildingCreator/dealerTechs/user');
    }

    getCountries(): Observable<any> {
        return this.http.get(fuseConfig.url + '/buildingAdmin/countries');
    }

    getCountryStates(id): Observable<any> {
        return this.http.get(fuseConfig.url + '/buildingAdmin/states/' + id);
    }

    createDealerTech(body): Observable<any> {
        return this.http.post(fuseConfig.url + '/buildingCreator/dealerTech/user', body);
    }

    updateDealerTech(body): Observable<any> {
        return this.http.put(fuseConfig.url + '/buildingCreator/dealerTech/user', body);
    }

    updateDealer(body): Observable<any> {
        return this.http.put(fuseConfig.url + '/buildingCreator/dealer/user', body);
    }

    toggleDealerStatus(body): Observable<any> {
        return this.http.put(fuseConfig.url + '/buildingCreator/dealer/changeStatus', body);
    }

    getBuildingSettings(id): Observable<any> {
        return this.http.get(fuseConfig.url + "/owner/buildingSettings/" + id);
    }

    getSmartKioskSettings(id): Observable<any> {
        return this.http.get(fuseConfig.url + "/owner/kioskSmart/" + id);
    }

    deleteResidents(body: any): Observable<any> {
        return this.http.post(fuseConfig.url + `/owner/residents/kioskSmart/delete`, body);
    }

    getPhotoResidents(building: string, resident:string): Observable<any> {
        return this.http.get( fuseConfig.url + `/owner/residents/kioskSmart/photo/${resident}/${building}`);
    }

    getDataOwner(building: string, unit:string): Observable<any> {
        return this.http.get( fuseConfig.url + `/owner/residents/user/${unit}/${building}`);
    }

    deletePhotoResidents(building: string, resident:string): Observable<any> {
        return this.http.delete( fuseConfig.url + `/owner/residents/kioskSmart/photo/${resident}/${building}`);
    }

    // RPGS · putSetPincodes (/owner/residents/kioskSmart/setPincode) retirado: el
    // API elimina esa ruta y el portal de propietarios ya no gestiona pines.

    updateResidentOnSmartKiosk(body): Observable<any> {
        return this.http.put(
            fuseConfig.url + `/owner/residents/kioskSmart/`,
            body
        );
    }

    updatePhotoResidentOnSmartKiosk(body): Observable<any> {
        return this.http.post(
            fuseConfig.url + `/owner/residents/kioskSmart/photo`,
            body
        );
    }

    postResidents(body: any): Observable<any> {
        return this.http.post(
            fuseConfig.url + `/owner/residents/kioskSmart/`,
            body
        );
    }

    postKioskSmartSettings(body: any): Observable<any> {
        return this.http.put(
            fuseConfig.url + `/owner/resident/kioskSmart/settings`,
            body
        );
    }

}